import type { IconData } from '@stacksjs/iconify-core'

export const otherUiWiFiOff: IconData = {
  "body": "<path fill=\"currentColor\" d=\"m0 1l1-1l1.9 1.9C4.487 1.32 6.206 1 8 1c2.96 0 5.71.866 8 2.35l-2 2.913A11 11 0 0 0 8 4.5c-.778 0-1.537.08-2.269.231l1.316 1.316Q7.517 6 8 6c1.903 0 3.671.556 5.143 1.51l-1.886 2.747L16 15l-1 1zm3.917 5.917a9 9 0 0 0-1.06.594l2 2.912a5.7 5.7 0 0 1 1.799-.767zM8 11a4.2 4.2 0 0 0-2.286.671L8 15l1.628-2.371z\"/>",
  "width": 24,
  "height": 24,
  "viewBox": "0 0 24 24"
}

export default otherUiWiFiOff
